import type { FaireThemeEntity } from "../../entity_types/theme";

export const luxury_impulse_gifts: FaireThemeEntity = {
  token: "luxury-impulse-gifts",
  type: "theme",
  name: "Luxury Impulse Gifts",
  description: "Small-batch jewelry sets and statement pieces that look high-end but retail for under $40. These are the perfect finishing touches for a customer's new look.",
  teaser: "As a brick-and-mortar boutique, offering these affordable luxury items near the point of sale is an excellent strategy to increase average transaction value through giftable impulse buys.",
  detail: "The context shows a range of items with accessible wholesale prices between $5.93 and $11.10, such as the Novaé Earring Set, making them ideal for high-margin retail under a $40 price point.",
  bgColor: "#E6D5C3",
  tileBgColor: "#593c6b",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_s7mxah3gtv",
    "p_bhw5g37tpm",
    "p_vndrc5e385",
    "p_a8g27yvxyn",
    "p_ut3tbs6mrw",
    "p_pdvfyz7trd",
    "p_ufjavmwa64",
    "p_sx6zye8wdd",
    "p_k5bk8exzkn",
    "p_uavgd4t79v",
    "p_pqf2f49nzz",
    "p_tpf2apke3k",
    "p_q5yt6mpwe2",
    "p_a2aqje85yt",
    "p_7aj8n8fwkr",
    "p_9de3mat7p2",
    "p_mt6dgyjj66",
    "p_en52fkxk94",
    "p_jhcrb92fnq",
    "p_jb455zfqe2",
    "p_uxpdx9rb2w",
    "p_hxbef8kp2q",
    "p_hr2c2qxn5f",
    "p_zcxs6hxgxs",
    "p_zmtpk6urpp",
    "p_d9qdrzx45t",
    "p_efa5ksyg38",
    "p_32vc8hf4e7",
    "p_xy86g89hcw",
    "p_93hyhdtyg4",
    "p_rzemzpvdgv",
    "p_fyh4x9vn2x",
    "p_n8qv8jwwwr",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
